import { render, staticRenderFns } from "./VCheck.vue?vue&type=template&id=708c72bd&scoped=true"
import script from "./VCheck.vue?vue&type=script&lang=js"
export * from "./VCheck.vue?vue&type=script&lang=js"
import style0 from "./VCheck.vue?vue&type=style&index=0&id=708c72bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708c72bd",
  null
  
)

export default component.exports